import {GameStateEnums} from '../../../../../shared/GameEnums.ts'
import {type UIGameMechanic} from '../UIGameEventController.ts'
import {type UIGameManager} from '../UIGameManager.ts'
import {MovingSpriteView} from '../../ui_canvas_engine/MovingSpriteView.ts'
import {getMerchantImageNameForPlayer, Sprites} from '../UIGameImageDictionary.ts'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler.ts'
import {Point} from '@colonist/game-mechanic-validators'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {type MechanicMerchantState} from '@colonist/game-states'

export class UIGameMerchantController implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private readonly merchantState: MechanicMerchantState
    private readonly merchantView: MovingSpriteView

    private lastMerchantTileIndex?: number | undefined

    constructor(uiGameManager: UIGameManager, merchantState: MechanicMerchantState) {
        this.uiGameManager = uiGameManager
        this.merchantState = merchantState
        this.lastMerchantTileIndex = merchantState.locationTileIndex
        this.uiGameManager.eventController.registerUIGameMechanic(this)

        const initialTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_merchant_green)
        const mapView = this.uiGameManager.mapController.mapView
        this.merchantView = new MovingSpriteView(0, 0, mapView.merchantRadius, mapView.merchantRadius, mapView, initialTexture)
        this.merchantView.zIndex = mapView.layers.robber
        const animate = false
        this.repositionMerchant(animate)
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.MapStateUpdated: this.updateMerchant(data); break
            case UIGameEventEnums.ShowTradeUI: this.displayMerchantBonusIcon(); break
            default: break
        }
    }

    private updateMerchant(animate: boolean) {
        if(this.lastMerchantTileIndex == this.merchantState.locationTileIndex) return
        this.hideMerchant()
        this.repositionMerchant(animate)
        this.lastMerchantTileIndex = this.merchantState.locationTileIndex
        this.uiGameManager.eventController.sendEvent(this.merchantState, UIGameEventEnums.MerchantStateUpdated)
    }

    private hideMerchant() {
        if(this.merchantView.parent == undefined) return
        this.merchantView.parent.removeChild(this.merchantView)
    }

    private repositionMerchant(animate: boolean) {
        if(this.merchantState.locationTileIndex == undefined) {
            this.hideMerchant()
            return
        }

        if(this.merchantState.owner == undefined) return
        const newTextureName = getMerchantImageNameForPlayer(this.merchantState.owner)
        const newTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites[newTextureName])
        this.merchantView.texture = newTexture

        const merchantPosition = this.getMerchantPosition(this.merchantState.locationTileIndex)

        const animationStartY = animate ? merchantPosition.y - this.uiGameManager.mapController.mapView.hexagonHeight : merchantPosition.y
        this.merchantView.x = merchantPosition.x
        this.merchantView.y = animationStartY
        this.uiGameManager.mapController.mapView.addChild(this.merchantView)
        this.merchantView.animationController.animateTo(merchantPosition)
    }

    private getMerchantPosition(tileIndex: number): Point {
        const tileHex = this.uiGameManager.gameController.mapValidator.tileState.tiles[tileIndex]
        const tileCenter = tileHex.hexFace.toPixel(this.uiGameManager.mapController.mapView.mapCenter, this.uiGameManager.mapController.mapView.hexagonHeight / 2)

        const mapView = this.uiGameManager.mapController.mapView
        const x = tileCenter.x + mapView.hexagonWidth / 4 - mapView.merchantRadius / 2
        const y = tileCenter.y - mapView.hexagonHeight / 4 + mapView.merchantRadius / 4

        return new Point(x, y)
    }

    private displayMerchantBonusIcon() {
        if(this.merchantState.owner != this.uiGameManager.gameController.myColor) return
        if(this.merchantState.activeTradeBonus == undefined) return

        this.uiGameManager.eventController.sendEvent(this.merchantState.activeTradeBonus, UIGameEventEnums.MerchantBankTradeRatioActive)
    }
}
